import { useTitle } from '@/shared/hooks/useTitle';
import { useUser } from '@/shared/hooks/useUser';
import { defineComponent, reactive, toRefs } from '@vue/composition-api';
import Sidebar from './sidebar/sidebar.component.vue';

// リアクティブな変数の型定義
export type ReactiveData = {
  isOpen: boolean;
  Menu: boolean;
  mainTitle: string;
  list: boolean;
  isSizeOver: boolean;
};

export default defineComponent({
  components: { Sidebar },
  setup() {
    const { title, icon } = useTitle();
    const { user } = useUser();

    const state = reactive<ReactiveData>({
      isOpen: true,
      Menu: false,
      mainTitle: '',
      list: false,
      isSizeOver: false, // ログインユーザー名が超過したか
    });

    /**
     * メインヘッダー部に表示するログインユーザー名取得
     */
    const getLoginUserName = () => {
      // ユーザー名を設定（後にstoreから取得するようにする）
      const loginUserName = user?.name || '';

      // ログインユーザー名が10文字より多い場合、11文字以降を表示しない
      if (loginUserName.length > 10) {
        // ログインユーザー名が超過したかのフラグをtrueにする
        state.isSizeOver = true;

        // 名前の10文字目までを取得し、11文字目を三点リーダーにする
        return loginUserName.substring(0, 10).concat('...');
      } else {
        return loginUserName;
      }
    };

    /**
     * ツールチップで表示するログインユーザーフルネーム取得
     */
    const getLoginUserFullName = () => {
      return user?.name || '';
    };

    /**
     * 子メニュー表示項目変更
     */
    function menuDisplay(
      menuChild: {
        text: string;
        icon: string;
        isAllow?: boolean;
        link: string;
        isFocus: boolean;
      }[],
    ) {
      // 修正後の子メニュー
      const menus: {
        text: string;
        icon: string;
        isAllow?: boolean;
        link: string;
        isFocus: boolean;
      }[] = [];

      let count = 0;

      // 子の数だけ繰り返す
      for (let i = 0; i < menuChild.length; i++) {
        // 子メニューのisAllow がfalse 以外の場合(未設定 or true)は表示する項目に加える
        if (menuChild[i].isAllow !== false) {
          menus[count] = menuChild[i];
          count++;
        }
      }
      return menus;
    }

    const onOpen = () => {
      state.isOpen = true;
    };

    const toggle = () => {
      state.isOpen = !state.isOpen;
    };

    return {
      ...toRefs(state),
      title,
      icon,
      getLoginUserName,
      getLoginUserFullName,
      onOpen,
      menuDisplay,
      toggle,
    };
  },
});
